import type { CheckboxGroupItem } from "@/components/molecules/CheckboxGroup/CheckboxGroup";
import { MultiSelectDropdownView } from "@/components/molecules/MultiSelectDropdown/MultiSelectDropdownView/MultiSelectDropdownView";
import type { SelectedId } from "@/components/molecules/MultiSelectDropdown/MultiSelectDropdownView/type";
import { useMultiSelect } from "@/components/molecules/MultiSelectDropdown/MultiSelectDropdownView/useMultiSelect";
import { useState } from "react";

export function MultiSelectDropdown(props: {
  items: CheckboxGroupItem[];
  selectedIds: SelectedId[];
  onChange: (ids: SelectedId[]) => void;
  placeholder?: string;
  disabled?: boolean;
}) {
  const { isChecked, toggle } = useMultiSelect(props.selectedIds, props.onChange);
  const [open, setOpen] = useState(false);
  return (
    <MultiSelectDropdownView
      items={props.items}
      isOpen={open}
      setOpen={setOpen}
      isChecked={isChecked}
      toggle={toggle}
      placeholder={props.placeholder}
      disabled={props.disabled}
      showPillsBelow={true}
    />
  );
}
